import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { STAGE } from "../constants";
import { setModalAttributes } from "../redux/slice/ModalSlice";

const useStageErrorHandler = ({ stage, prevStage, message }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (stage === STAGE.CREDIT_QUEUE) {
      dispatch(
        setModalAttributes({
          open: true,
          message:
            "Looks like, we would require to screen your application a little more. We will get back to you in next 24 hours.",
          type: stage,
        })
      );
    }
    if (stage === STAGE.CLOSED) {
      dispatch(setModalAttributes({ open: true, message, type: stage }));
    }
    return () => {
      dispatch(setModalAttributes({ open: false, message: "", type: "" }));
    };
  }, [stage, prevStage, message]);
};

export default useStageErrorHandler;
